module.exports = __webpack_public_path__ + "img/arr-dark.4f316447.svg";